<script setup lang="ts">
    import { inject, onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';

    const BACKEND_URL = inject('BACKEND_URL');
    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        banners: [] as any, 
        top_categories: [],
        top_produits: [],
    });
    const errors = reactive({
        banners: "",
        top_categories: "",
        top_produits: "",
    });
    const startupFormDatas = reactive({
        categories: [] as any[],
        produits: [] as any[],
    });

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        Object.assign(startupFormDatas, {
            categories: form_datas.categories,
            produits: form_datas.produits,
        });
        if (form_datas?.settings) {
            const item = form_datas.settings as any;
            if (item.banners) {
                Object.keys(item.banners).forEach((banniereKey) => {
                    if (item.banners[banniereKey]) {
                        formData.banners[banniereKey] = {
                            file_preview: BACKEND_URL + '/assets/market_banners/300/' + item.banners[banniereKey],
                            file: null,
                        };
                    }
                });
            }
            console.log(formData.banners);
            formData.top_categories = item.top_categories || [];
            formData.top_produits = item.top_produits || [];
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function validate() {
        let isValid = true;
        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = new FormData();
            formData.banners.forEach((banniere: any, banniereId: string) => {
                if (banniere.file) {
                    formToUpload.append(`banners[${banniereId}]`, banniere.file, banniere.name);
                } else {
                    formToUpload.append(`banners[${banniereId}]`, '');
                }
            });
            formData.top_categories.forEach((categorieId: string, index: number) => {
                formToUpload.append(`top_categories[${index}]`, categorieId);
            });
            formData.top_produits.forEach((produitId: string, index: number) => {
                formToUpload.append(`top_produits[${index}]`, produitId);
            });
            
            await axios.post(`/backoffice/market-settings/save`, formToUpload);
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    function onFileBanniereUploaded(index: number, uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData.banners[index] = { file: uploadedFile.file, name: uploadedFile.file_name };
    }
</script>

<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-30"></div>

        <section class="s20_mobile px-4">
            <div class="widget px-7 py-7">
                <h4 class="font-semibold mb-5">Paramètres Market <span class="text-sm text-grey-500"></span></h4>

                <div class="item-row d-flex mb-3">
                    <div class="label f-s-14">Bannières :</div>
                </div>
                <div class="d-flex justify-content-center">
                    <custom-bloc-file-input title="Bannière 1" id="banniere_1" @uploaded="onFileBanniereUploaded(0, $event)" :preview="formData.banners[0]?.file_preview"  />
                    <custom-bloc-file-input title="Bannière 2" id="banniere_2" @uploaded="onFileBanniereUploaded(1, $event)" :preview="formData.banners[1]?.file_preview"  />
                </div>
                
                <div class="form-field-floating full my-5">
                    <select class="form-input-select" v-model="formData.top_categories" name="top_categories" id="top_categories" multiple="true" size="1">
                        <option :value="categorie.id" v-for="(categorie, index) in startupFormDatas.categories" :key="'categorie_' + index">
                            {{ categorie.nom }}
                        </option>
                    </select>
                    <label for="top_categories">Top Catégories</label>
                </div>
                
                <div class="form-field-floating full my-5">
                    <select class="form-input-select" v-model="formData.top_produits" name="top_produits" id="top_produits" multiple="true" size="1">
                        <option :value="produit.id" v-for="(produit, index) in startupFormDatas.produits" :key="'produit_' + index">
                            {{ produit.nom }}
                        </option>
                    </select>
                    <label for="top_produits">Top Produits</label>
                </div>

                <div class="clear-both h-30"></div>
                <span v-if="!!errorMessage" class="text-red">{{ errorMessage }}</span>
                <p class="text-text-xs text-grey-500 mb-5"><b class="color-danger text-xs">*</b> Les champs marqués d'un astérisque sont obligatoires</p>
                <div class="flex gap-2">
                    <custom-button id="btn-submit" type="button" :classesList="'btn lg w-100'" :loading="loading" @click="onSubmit()">
                        <img src="/icons/icon-enregistrer.svg" class="btn-icon" alt="" />
                        <span>Enregistrer</span>
                    </custom-button>
                </div>
                
            </div>
        </section>
        
    </section>
</template>
